import { DISCIPLINES, FOR_UPDATE, StudentServicePath, WEEKLY_SCHEDULE } from "utils/constants";
import EditWeeklySchedule from "./Edit";

//permissions
export const resources = {
  isMenu: false,
  name: StudentServicePath + WEEKLY_SCHEDULE + "/:weeklyScheduleId/" + DISCIPLINES + "/:disciplineId/" + FOR_UPDATE,
  title: "Редактиране на седмично разписание",
  custom: <EditWeeklySchedule />,
};
